import { TotalText } from './PlanTableTotalFooter.styles'
import { useTranslation } from 'react-i18next'

const PlanTableTotalFooter = () => {
  const { t } = useTranslation()

  return <TotalText>{t('planTableTotalFooter.totalText')}</TotalText>
}

export default PlanTableTotalFooter
